import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ImportLancamentosBancoFileUpload } from '@models/import-lancamentos-banco-file-upload';
import { OrigemLancamento } from '../models/enums/origem-lancamento';
import { TipoContaBancoEnum } from '../models/enums/tipo-conta-banco-enum';
import { LancamentoPrincipal } from '../../pages/financeiro/conciliacao/models/lancamento-principal';
import { ApiService } from './api.service';
import { MessageService } from './message.service';
import { ValidationResult } from '@models/validation-result';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

@Injectable({
  providedIn: 'root'
})
export class ImportLancamentosService {

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private dialog: MatDialog
  ) { }

  private importLancamentoApiCall(file: File, contaId: number, origem: OrigemLancamento): Observable<LancamentoPrincipal[]> {
    const formData = new FormData();
    formData.append('formFile', file, file.name);

    if (origem === OrigemLancamento.Banco) {
      formData.append('contaBancoId', contaId.toString());
      const data: ImportLancamentosBancoFileUpload = {
        contaBancoId: contaId,
        formFile: file
      }
      return this.apiService.post<LancamentoPrincipal[]>(`/lancamento-banco-excel/importar-lancamentos`, null, formData);
    }
    else {
      return this.apiService.post<LancamentoPrincipal[]>(`/lancamento-caixa-excel/importar-lancamentos`, null, formData);
    }


  }

  private importLancamentoCartaoApiCall(file: File, contaBancoId: number, confirmado: boolean): Observable<void> {
    const formData = new FormData();
    formData.append('formFile', file, file.name);
    formData.append('contaBancoId', contaBancoId.toString());
    formData.append('confirmadoContinuarImportacaoPossivelRepetida', confirmado.toString());

    return this.apiService.post<void>(`/lancamento-banco-excel/importar-lancamentos-cartao`, null, formData);
  }

  public importLancamentos(
    inputElement: HTMLInputElement,
    contaId: number,
    origem: OrigemLancamento,
    tipoContaBanco?: TipoContaBancoEnum
  ): void {
    const file: File | null = inputElement.files === null ? null : inputElement.files[0];
    inputElement.value = '';

    if (!file) return;

    if (origem === OrigemLancamento.Banco && tipoContaBanco === TipoContaBancoEnum.CartaoCredito) {
      this.importarLancamentoCartao(file, contaId, false);
      return;
    }

    this.importLancamentoApiCall(file, contaId, origem).subscribe(() => {
      this.messageService.showToastSuccess("Salvo com sucesso.");
    });
  }

  private importarLancamentoCartao(file: File, contaBancoId: number, confirmado: boolean): void {
    this.importLancamentoCartaoApiCall(file, contaBancoId, confirmado).subscribe({
      next: () => this.messageService.showToastSuccess("Salvo com sucesso."),
      error: (err: HttpErrorResponse) => {
        if (err.status === 409) {
          this.abrirConfirmacaoSobreposicao(file, contaBancoId);
          return;
        }

        const validationResult = err.error as ValidationResult;
        if (validationResult?.errors?.length)
          this.messageService.showToastErrorValidation(validationResult);
      }
    });
  }

  private abrirConfirmacaoSobreposicao(file: File, contaBancoId: number): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true
    });
    dialogRef.componentInstance.titulo = 'Possível importação repetida';
    dialogRef.componentInstance.mensagem = 'Existem lançamentos no arquivo com data igual ou anterior à última importação. Deseja continuar mesmo assim?';
    dialogRef.componentInstance.textoBtnConfirmacao = 'Importar mesmo assim';
    dialogRef.componentInstance.acaoConfirmacao = () => this.importarLancamentoCartao(file, contaBancoId, true);
  }
}
